import React from 'react';
import FilteredAutomationList from '../components/FilteredAutomationList';

const FSBONoAgents = () => {
    const breadcrumbItems = [
        { label: 'Home', href: '/' },
        { label: 'Automation Trigger', href: '/automation' },
        { label: 'FSBO - No Agents', active: true }
    ];

    return (
        <FilteredAutomationList
            completionStatus="fsbo_no_agents"
            title="FSBO - No Agents"
            subtitle="For Sale By Owner automation runs with no agents present"
            breadcrumbItems={breadcrumbItems}
        />
    );
};

export default FSBONoAgents;